<template>
  <div>
    <KllkListCell
      v-for="item in allList"
      :imageUrl="item.imageUrl"
      @on-sent="onSent(item)"
      @on-unpub="onUnPub(item)"
      @on-edit="onEdit(item)"
      @on-del="onDel(item)"
      :imageWidth="130"
      :imageHeight="170"
      :publish="item.publish"
      :lang="item.languageType"
    >
      <div slot="info" class="info">
        <p class="title" @click="onView(item)">{{ item.title }}</p>
        <p class="desc">{{ item.description }}</p>
        <p class="data-order">
          <span class="sequence">{{ item.sequence }}</span>
          |
          <span class="data"> {{ item.createTime }}</span>
        </p>
      </div>
    </KllkListCell>
  </div>
</template>
<script>
import KllkListCell from "../../components/kllk-list-cell";
// api
import { PostPubBook, DelBook, PostOutBook } from "../../api/book";

export default {
  components: {
    KllkListCell,
  },
  props: {
    allList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 查看查看
    onView(cell) {
      this.$router.push({
        name: "bookView",
        query: {
          bookId: cell.bookId,
        },
      });
    },
    onSent(cell) {
      this.$confirm("确定发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          PostPubBook(cell.bookId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "发布成功!",
              });
              this.$emit("on-update");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 下架
    onUnPub(cell) {
      this.$confirm("确定下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          PostOutBook(cell.bookId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "下架成功!",
              });
              this.$emit("on-update");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    onEdit(cell) {
      this.$emit("on-edit", cell);
    },
    onDel(cell) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelBook(cell.bookId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.$emit("on-update");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style scoped lang="less">
.info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 180px;
  padding: 15px;
  box-sizing: border-box;
}
.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.title {
  font-size: 20px;
  max-width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    color: #394f9a;
    cursor: pointer;
  }
}

.data-order {
  .data {
    color: #8a8a8a;
    margin-left: 5px;
  }
  .sequence {
    width: 20px;
    border-radius: 50%;
    background-color: #46b5ff;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    color: #fff;
    margin-right: 5px;
  }
}
</style>
